import { ROUTES } from "@routing/routes";
import { NotFoundContent } from "@/Features/Shared/ErrorPages/NotFoundContent";

export const NotFoundPage = () => {
    return <NotFoundContent primaryTo={ROUTES.HOME} primaryLabel="Go home" />;
};
